import { List, Record } from "immutable";
import { Nullable } from ".";
import { emailEventFromJSON, EmailEventRecord, IEmailEvent } from "common/records/EmailEvent";
import { checkDate } from "common/helpers/Date";

export const emailFromJSON = (json: Partial<IEmailData>): EmailRecord => {
  const record: IEmailRecord = { ...(json as any) };
  if (json.events) {
    record.events = List(json.events.map((event) => emailEventFromJSON(event)));
  }
  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new EmailRecord(record);
};

export interface IEmailData {
  id: number;
  bcc: string;
  cc: string;
  from: string;
  kind: string;
  message_id: string;
  status: string;
  subject: string;
  to: string;
  date: Date;
  provider: string;
  events: IEmailEvent[];

  created_at: Date;
  updated_at: Date;
}

export interface IEmailRecord {
  id: number;
  bcc: string;
  cc: string;
  from: string;
  kind: string;
  message_id: string;
  status: string;
  subject: string;
  to: string;
  date: Nullable<Date>;
  provider: string;
  events: List<EmailEventRecord>;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

export const defaultEmailProps: IEmailRecord = {
  id: 0,
  bcc: "",
  cc: "",
  from: "",
  kind: "",
  message_id: "",
  status: "",
  subject: "",
  to: "",
  date: null,
  provider: "",
  events: List<EmailEventRecord>(),

  created_at: null,
  updated_at: null,
};

export class EmailRecord extends Record(defaultEmailProps) implements IEmailRecord {}
